import { ISearchListColumn } from 'component/Search/IColumnExtensionType';
import { get } from 'lodash';
import { recursiveHandleColumns } from './recursiveHandleColumns';

export const columnDefaultRender = <T>(
  item: T,
  column?: ISearchListColumn<T>
): import('exceljs').CellValue | any[] => {
  if (!column?.data) {
    // using lodash `get` here allows for support of drilling in if item has objects as properties
    return column && get(item, column?.fieldName || column?.key);
  }

  return recursiveHandleColumns(
    column.data,
    item,
    column.fieldName || column.key
  );
};
